import { render, staticRenderFns } from "./table.vue?vue&type=template&id=922016f8&scoped=true"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"
import style0 from "./table.vue?vue&type=style&index=0&id=922016f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922016f8",
  null
  
)

export default component.exports